import DataGrid2 from '..';
import { Methods } from './methods';

export function bindMethods(this: DataGrid2) {
	// ClientMethods
	this.reload = Methods.reload.bind(this);
	this.newRow = Methods.newRow.bind(this);
	this.getSelectedRows = Methods.getSelectedRows.bind(this);
	this.addColumns = Methods.addColumns.bind(this);
	this.getRowValues = Methods.getRowValues.bind(this);
	this.getCellValue = Methods.getCellValue.bind(this);
	this.getSelectedRows = Methods.getSelectedRows.bind(this);
	this.getUniqueDataField = Methods.getUniqueDataField.bind(this);
	this.rowChangeAction = Methods.rowChangeAction.bind(this);
	this.deleteRows = Methods.deleteRows.bind(this);
	this.updateColumnCells = Methods.updateColumnCells.bind(this);
	this.sortColumn = Methods.sortColumn.bind(this);
	this.insertRow = Methods.insertRow.bind(this);
	this.insertRows = Methods.insertRows.bind(this);
	this.updateRow = Methods.updateRow.bind(this);
	this.updateRows = Methods.updateRows.bind(this);
	this.removeRow = Methods.removeRow.bind(this);
	this.removeRows = Methods.removeRows.bind(this);

	// Private Methods
	this.__checkIncreaseCommitId = this.__checkIncreaseCommitId.bind(this);
	this.__notifyDataGridRows = this.__notifyDataGridRows.bind(this);
	this.__getBCColumn = this.__getBCColumn.bind(this);
	this.__retrieveDataGridInstance = this.__retrieveDataGridInstance.bind(this);
	this.__loadProperties = this.__loadProperties.bind(this);
	this.__onChangesChange = Methods.onChangesChange.bind(this);
	this.__calculateHeight = Methods.calculateHeight.bind(this);
	this.__onInitNewRow = Methods.onInitNewRow.bind(this);
	this.__onContextMenuOpen = Methods.onContextMenuOpen.bind(this);
	this.__onExporting = Methods.onExporting.bind(this);
	this.__onEditorPreparing = Methods.onEditorPreparing.bind(this);
	this.__onRowDblClick = Methods.onRowDblClick.bind(this);
	this.__onRowRemoving = Methods.onRowRemoving.bind(this);
	this.__onRowRemoved = Methods.onRowRemoved.bind(this);
	this.__onRowInserting = Methods.onRowInserting.bind(this);
	this.__onRowInserted = Methods.onRowInserted.bind(this);
	this.__onRowUpdating = Methods.onRowUpdating.bind(this);
	this.__onRowUpdated = Methods.onRowUpdated.bind(this);
	this.__onSelectionChanged = Methods.onSelectionChanged.bind(this);
	this.__onSelectionChanging = Methods.onSelectionChanging.bind(this);
	this.__onEditingStart = Methods.onEditingStart.bind(this);
	this.__onCellPrepared = Methods.onCellPrepared.bind(this);
	this.__onEditCanceling = Methods.onEditCanceling.bind(this);
	this.__bindCustomStore = Methods.bindCustomStore.bind(this);
	this.__bindArrayStore = Methods.bindArrayStore.bind(this);
	this.__onContentReady = Methods.onContentReady.bind(this);
	this.__customSave = Methods.customSave.bind(this);
	this.__customLoad = Methods.customLoad.bind(this);
	this.__setSelectionResult = Methods.setSelectionResult.bind(this);
	this.__emitRelationEvents = Methods.emitRelationEvents.bind(this);
	this.__onReorder = Methods.onReorder.bind(this);

	// Custom Bindings
	this.__onSummaryChanged = Methods.onSummaryChanged;
}
